import { ContentfulClientApi } from 'contentful';
import { productGroupsConfig as contestProducts } from '../lib/productGroups/contest';
import { mapContentfulDataToProductAttributes } from './mapContentfulDataToProductAttributes';
import type { ProductGroup as ProductGroupMerge, ProductGroupName } from '../types';
import type {
    ProductDetailsPageContestModel,
    ProductDetailsPageSingleFixedPriceProjectModel,
} from '../types/Contentful';

type ProductGroup = Omit<ProductGroupMerge, 'productNames' | 'designInspirationCategoryKey'>;

export async function getPageConfigFromContentful(
    name: ProductGroupName,
    contentfulClient?: ContentfulClientApi,
    contentfulLanguage?: string
): Promise<ProductGroup> {
    const contestProduct = Object.values(contestProducts).some((product) => product.name === name);

    if (contentfulClient && contentfulLanguage) {
        const productDetailsPageEntries = contestProduct
            ? await contentfulClient.getEntries<ProductDetailsPageContestModel>({
                  content_type: 'productDetailsPageContest',
                  'fields.key[match]': name,
                  limit: 1,
                  locale: contentfulLanguage,
              })
            : await contentfulClient.getEntries<ProductDetailsPageSingleFixedPriceProjectModel>({
                  content_type: 'productDetailsPageSingleFixedPriceProject',
                  'fields.key[match]': name,
                  limit: 1,
                  locale: contentfulLanguage,
              });

        if (!productDetailsPageEntries || productDetailsPageEntries.items.length === 0) {
            throw new Error('missing product config data');
        }

        const pageConfig = productDetailsPageEntries.items[0].fields;

        return {
            name,
            attributes: mapContentfulDataToProductAttributes(pageConfig),
        };
    } else {
        throw new Error('missing product config data');
    }
}
